export default "__VITE_ASSET__DrMMcQrf__"